var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import clsx from 'clsx';
import { XR } from '../../../xr';
export function XTableCell(props) {
    var type = props.type;
    var cellProps = {};
    var element = null;
    if (['checkbox', 'toggle'].includes(type)) {
        var _a = props, checked_1 = _a.checked, onChangeValue_1 = _a.onChangeValue, disabled = _a.disabled;
        cellProps.align = 'center';
        if (type === 'toggle') {
            element = (React.createElement(XR.Button, { variant: 'text', color: checked_1 ? 'primary' : 'washed', onClick: function () { return onChangeValue_1(!checked_1); }, icon: checked_1 ? 'toggle_on' : 'toggle_off', className: clsx({ checked: checked_1 }), disabled: disabled }));
        }
        else {
            element = (React.createElement(XR.Button, { variant: 'text', color: checked_1 ? 'primary' : 'washed', onClick: function () { return onChangeValue_1(!checked_1); }, icon: checked_1 ? 'check_box' : 'check_box_outline_blank', className: clsx({ checked: checked_1 }), disabled: disabled }));
        }
    }
    return (React.createElement("td", __assign({ className: clsx('XTableCell', type, "type-" + type) }, cellProps), element));
}
